//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import LabeledControlLayout from '@/components/shared/labeled-control-layout'
import {mapActions, mapState, mapGetters} from 'vuex'
import {getShoppingCartSID} from '@/utils/helpers'
import {adminCodes} from "../../../../../MultiSiteClient/enums/adminSettings";
import forgotPasswordCard from "../common/forgot-password-card";
import ChangePasswordCard from "../common/change-password-card";

export default {
  name: 'user-login',
  components: {
    LabeledControlLayout,
    forgotPasswordCard,
    ChangePasswordCard
  },
  props: {
    redirectTo: {
      type: String,
      required: false,
      default: 'home',
    },
    section: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visibleForm: 'signIn',
      signInForm: {
        data: {
          email: '',
          password: '',
        },
        emailRules: [
          (v) => !!v || 'This is a required field!'
        ],
        rules: {
          required: (value) => !!value || 'This is a required field!',
          min: (v) => (v && v.length >= 8) || 'Min 8 characters!',
        },
        valid: false,
        rememberMe: false,
      },
      currentUserName: '',
      currentUserID: 0,
    }
  },
  async mounted() {
    let userInfo = this.getSavedUserInfo();
    if(userInfo) {
      this.signInForm.data.email = userInfo.email;
      this.signInForm.data.password = userInfo.password;
      this.signInForm.rememberMe = true;
    }
  },
  computed: {
    ...mapState('common/cache', ['loadSettings']),
    backgrounColor(){
      return {
        backgroundColor: this.section.primary_color.fieldValue.value
      }
    },
    fontColor(){
      return {
        color: this.section.primary_color.fieldValue.value
      }
    },
    getSignUpUrl(){
      let targetURL = "nmd-sign-up"
      if(this.section.sign_up_url && this.section.sign_up_url.fieldValue.value){
        targetURL = this.section.sign_up_url.fieldValue.value;
      }
      return targetURL;
    }
  },
  methods: {
    ...mapActions('backoffice/settings', ['fetchAdminSettingByCode']),
    ...mapActions('common/cache', ['loadingCache']),
    ...mapActions('rememberedUser', ['saveUser','removeSavedUser']),
    ...mapGetters('rememberedUser',['getSavedUserInfo']),
    async localLoginAndRedirectHandler(email, password, checkForRememberedUser = true) {
      try {
        const response = await this.$auth.loginWith('local', {
          data: {
            username: email,
            password: password,
            sessionId: getShoppingCartSID(),
          },
          redirect: false
        })
        if (response.status === 200 && response.data.token) {
          if(checkForRememberedUser && this.signInForm.rememberMe) {
            this.saveUser({email: email, password: password})
          }
          this.$toast.success('Logged in!')
          await this.$store.dispatch('shoppingCart/getCountBySessionId')
          await this.loadingCache()
          const redirectFromUrl = this.$route?.query?.redirectBackTo?.toString();
          let targetRoute = "/home";

          if (redirectFromUrl && redirectFromUrl.length) {
            targetRoute = redirectFromUrl;
            if (redirectFromUrl.includes("shopping-cart")){
              this.$toast.success('Item added to cart successfully!')
            }
          } else if (this.section?.redirect_after_sign_in?.fieldValue?.value) {
            targetRoute = this.section.redirect_after_sign_in.fieldValue.value;
          }

          if (this.$route.path !== targetRoute) {
            this.$router.push(targetRoute);
          }
        } else {
          this.$toast.error('Invalid username or password!')
        }
      }catch (e) {
      }
    },
    async signIn() {
      if (this.$refs.signInForm.validate()) {
        try {
          const changePasswordResponse = await this.$axios.$post(
            `/auth/portal-login-check-must-change-password`,
            {
              username: this.signInForm.data.email,
              password: this.signInForm.data.password,
            }
          )
          if(changePasswordResponse) {
            if (changePasswordResponse.hasErrors && changePasswordResponse.errorMessages.error) {
              this.$toast.error(changePasswordResponse.errorMessages.error)
            } else if (changePasswordResponse.value
              && changePasswordResponse.value.mustChangePasswordOnNextLogin
              && changePasswordResponse.value.mustChangePasswordOnNextLogin === true
              && changePasswordResponse.value.userName
              && changePasswordResponse.value.id) {
              this.visibleForm = 'mustChangePassword'
              this.currentUserName = changePasswordResponse.value.userName;
              this.currentUserID = changePasswordResponse.value.id;
              return
            }
            await this.localLoginAndRedirectHandler(this.signInForm.data.email, this.signInForm.data.password)
          }
        } catch (err) {
          this.$toast.error('Error while logging in!')
        }
      }
    },
    async loginWithNewPassword(loginInfo) {
      await this.localLoginAndRedirectHandler(loginInfo.username, loginInfo.password, false)
    },
    removeRememberedUserOnUncheck() {
      if(!this.signInForm.rememberMe) {
        this.removeSavedUser();
      }
    }
  },
}
